/* import __COLOCATED_TEMPLATE__ from './visibility-section.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';

interface Args {
  selectedPreset: string;
  audienceRuleset: $TSFixMe;
  rulesEditorConfig: $TSFixMe;
  onSelectPreset: (preset: string) => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class SalesVisibilitySection extends Component<Signature> {
  get isSpecificAudience(): boolean {
    return this.args.selectedPreset === 'specific';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::VisibilitySection': typeof SalesVisibilitySection;
  }
}
